import { createElement } from 'react';
import { ApiBlueprint, createFrontendModule, discoveryApiRef, fetchApiRef } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { techRadarApiRef, TechRadarApiClient } from './api';

const techRadarCard = EntityCardBlueprint.make({
  name: 'techradar-card',
  params: {
    type: 'content',
    filter: {
      '$all': [
      {
        kind: "Component"
      },
      {
        '$any': [{ "spec.type": "library" }, { "spec.type": "platform" }, { "spec.type": "technique" }, { "spec.type": "language" }, { "spec.type": "framework" }, { "spec.type": "tool" }]
      }
    ]
    },
    loader: async () => {
      const { TechRadarStatus } = await import(
        './components/TechRadarStatus/TechRadarStatus'
      );
      return createElement(TechRadarStatus);
    },
  },
});

const techRadarApi = ApiBlueprint.make({
  name: 'techradar-api',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechRadarApiClient({ discoveryApi, fetchApi }),
    }),
});

export const catalogModuleTechradarCard = createFrontendModule({
  pluginId: 'catalog',
  extensions: [techRadarCard, techRadarApi],
});
